import { GameData } from '../api/types/GameData';
import { TeamVm } from './TeamVm';

export class GameVm {
    constructor(gameData: GameData) {
        this.gameId = gameData.gameId.toString();
        this.leagueName = gameData.leagueName;
        this.homeTeam = new TeamVm(gameData.homeTeam); // Creating a new instance of TeamVm
        this.awayTeam = new TeamVm(gameData.awayTeam); // Creating a new instance of TeamVm
        this.startDate = new Date(gameData.startDate); // TODO convert to date object
    }

    gameId: string;
    leagueName: string;
    homeTeam: TeamVm;
    awayTeam: TeamVm;
    startDate: Date;
}